import React, { useState, useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import {
    FaChartBar,
    FaCalendarAlt,
    FaUsers,
    FaCog,
    FaSignOutAlt,
    FaSitemap,
    FaList
} from "react-icons/fa";
import "./AdminSidebar.css";

const AdminSidebar = () => {
    const [isExpanded, setIsExpanded] = useState(false);
    const location = useLocation();
    const navigate = useNavigate();

    useEffect(() => {
        // Save sidebar state to localStorage
        const savedState = localStorage.getItem("sidebarExpanded");
        if (savedState !== null) {
            setIsExpanded(JSON.parse(savedState));
        }
    }, []);

    useEffect(() => {
        localStorage.setItem("sidebarExpanded", JSON.stringify(isExpanded));
    }, [isExpanded]);

    const handleToggle = () => {
        setIsExpanded((prev) => !prev);
        console.log("Sidebar expanded:", !isExpanded);
    };

    const handleLogout = () => {
        localStorage.removeItem("token");
        localStorage.removeItem("isAdmin");
        navigate("/admin/login");
    };

    return (
        <nav className={`admin-sidebar ${isExpanded ? "expanded" : ""}`}>
            <div className="sidebar-header">
                {/* Toggle Button */}
                <button className="toggle-btn" onClick={handleToggle}>
                    <FaList />
                </button>
            </div>

            <ul>
                <li className={location.pathname === "/admin/dashboard" ? "active" : ""}>
                    <Link to="/admin/dashboard">
                        <FaSitemap />
                        {isExpanded && <span>Dashboard</span>}
                    </Link>
                </li>
                <li className={location.pathname === "/admin/events" ? "active" : ""}>
                    <Link to="/admin/events">
                        <FaCalendarAlt />
                        {isExpanded && <span>Manage Events</span>}
                    </Link>
                </li>
                <li className={location.pathname === "/admin/analytics" ? "active" : ""}>
                    <Link to="/admin/analytics">
                        <FaChartBar />
                        {isExpanded && <span>Analytics</span>}
                    </Link>
                </li>
                <li className={location.pathname === "/admin/users" ? "active" : ""}>
                    <Link to="/admin/users">
                        <FaUsers />
                        {isExpanded && <span>Users Data</span>}
                    </Link>
                </li>
                <li className={location.pathname === "/admin/settings" ? "active" : ""}>
                    <Link to="/admin/settings">
                        <FaCog />
                        {isExpanded && <span>Settings</span>}
                    </Link>
                </li>
                <li className="logout-link">
                    <Link to="#" onClick={(e) => { e.preventDefault(); handleLogout(); }}>
                        <FaSignOutAlt />
                        {isExpanded && <span>Logout</span>}
                    </Link>
                </li>
            </ul>
        </nav>
    );
};

export default AdminSidebar;
